import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';

export const Home = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isLoggedIn = !!localStorage.getItem('token');

  return (
    <Layout title="OJESI" subtitle="🚗 ojesi.cafee.id">
      {!isLoggedIn ? (
        <>
          <div className="tg-card">
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: '48px' }}>🚗</div>
              <h2>Selamat Datang di OJESI!</h2>
              <p style={{ color: 'var(--tg-gray)' }}>Ojek Online Khusus Wanita & Umum</p>
              <Link to="/login" className="tg-btn tg-btn-primary" style={{ marginTop: '16px' }}>Login</Link>
              <Link to="/register?reff=ADMIN001" className="tg-btn tg-btn-outline" style={{ marginTop: '8px' }}>Daftar</Link>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="tg-card">
            <div className="tg-card-title">💰 Saldo Anda</div>
            <div style={{ fontSize: '24px', fontWeight: '700', color: '#fff' }}>Rp 50.000</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', padding: '0 16px' }}>
            <Link to="/order/ojek" className="tg-card" style={{ textAlign: 'center', textDecoration: 'none' }}>
              <div style={{ fontSize: '32px' }}>🛵</div>
              <div className="tg-card-title">Ojek</div>
            </Link>
            <Link to="/order/food" className="tg-card" style={{ textAlign: 'center', textDecoration: 'none' }}>
              <div style={{ fontSize: '32px' }}>🍔</div>
              <div className="tg-card-title">Food</div>
            </Link>
            <Link to="/order/barang" className="tg-card" style={{ textAlign: 'center', textDecoration: 'none' }}>
              <div style={{ fontSize: '32px' }}>📦</div>
              <div className="tg-card-title">Barang</div>
            </Link>
            <Link to="/history" className="tg-card" style={{ textAlign: 'center', textDecoration: 'none' }}>
              <div style={{ fontSize: '32px' }}>📊</div>
              <div className="tg-card-title">Riwayat</div>
            </Link>
          </div>

          <div className="tg-card">
            <div className="tg-card-title">🔗 Kode Referral</div>
            <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
              <code style={{ flex: 1, padding: '8px 12px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', fontSize: '14px' }}>
                {user.referral_code || 'CUS-XXXXX'}
              </code>
              <button className="tg-btn tg-btn-primary" style={{ width: 'auto', padding: '8px 16px', fontSize: '12px' }}>
                📋 Copy
              </button>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
};
